import React from 'react';
import {useForm} from "@inertiajs/react";
import {route} from "ziggy-js";
import useWithStore from "@/Hooks/useWithStore";
import {Dialog} from '@mui/material';
import {Error} from "@/Components/Error";
import Checkbox from "@/Components/Checkbox";
import Svg from "@/Components/Svg";
import Link from "@/Layouts/Link";
import reachGoalYM from "@/Helpers/ReachGoalYM";
import InertiaTextInput from "@/Components/Inertia/InertiaTextInput";

const JobsForm = (props) => {
    const {stores = {}, user = {}} = props;
    const {modalStore = {}} = stores;

    const initialValues = {
        name: user.name ?? '',
        phone: user.phone ?? '',
        email: user.email ?? '',
        position: '',
        link_to_resume: '',
        description: '',
        errorMessage: '',
        checkedPersonal: true,
    }
    const form = useForm(initialValues);
    const {data, setData, post, processing, errors, wasSuccessful} = form;

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('sendMailJobs'), {
            onSuccess: (page) => {
                // Отправка заявки с формы «Резюме» (ТЗ по целям от агенства)
                reachGoalYM('jobs_submit');
            },
            onError: errors => {
                //
            },
        });
    };

    return <Dialog id={`modal`}
                   className={`modal modal__jobs`}
                   open={modalStore.flagModalJobsForm}
                   onClose={() => modalStore.closeModalJobsForm()}
                   maxWidth={`sm`} //xs sm md lg xl
                   fullWidth>
        <div className={`modal__header`}>
            <div className={`dagger-box`} onClick={() => modalStore.closeModalJobsForm()}>
                <Svg id={`dagger-close`} className={`MuiSvgIcon-root svg__dagger-close`} />
            </div>
            <p className={`modal-title`}>Резюме</p>
        </div>
        <div className={`modal__body`}>
            {!wasSuccessful ?
                <form className={`form form__jobs${processing ? ' load' : ''}`} onSubmit={handleSubmit}>
                    <div className={`form__itemNew`}>
                        <input name={`name`}
                               type={`text`}
                               placeholder={`Имя *`}
                               value={data.name}
                               onChange={onHandleChange}
                               className={`text-inputNew${errors.name ? ' error' : ''}`}
                        />
                        <label className={`text-labelNew`}>Имя *</label>
                        <Error message={errors.name} />
                    </div>
                    <InertiaTextInput
                        name={`phone`}
                        type={`tel`}
                        mask={`+7 (999) 999 99 99`}
                        label={`Телефон *`}
                        form={form}
                    />
                    <div className={`form__itemNew`}>
                        <input name={`email`}
                               type={`email`}
                               placeholder={`Email *`}
                               value={data.email}
                               onChange={onHandleChange}
                               className={`text-inputNew${errors.email ? ' error' : ''}`}
                        />
                        <label className={`text-labelNew`}>Email *</label>
                        <Error message={errors.email} />
                    </div>
                    <div className={`form__itemNew`}>
                        <input name={`position`}
                               type={`text`}
                               placeholder={`Желаемая должность`}
                               defaultValue={modalStore.jobsName ? modalStore.jobsName : data.position}
                               onChange={onHandleChange}
                               className={`text-inputNew${errors.position ? ' error' : ''}`}
                        />
                        <label className={`text-labelNew`}>Желаемая должность</label>
                        <Error message={errors.position} />
                    </div>
                    <div className={`form__itemNew`}>
                        <input name={`link_to_resume`}
                               type={`text`}
                               placeholder={`Ссылка на резюме`}
                               value={data.link_to_resume}
                               onChange={onHandleChange}
                               className={`text-inputNew${errors.link_to_resume ? ' error' : ''}`}
                        />
                        <label className={`text-labelNew`}>Ссылка на резюме</label>
                        <Error message={errors.link_to_resume} />
                    </div>
                    <div className={`form__itemNew`}>
                        <textarea name={`description`}
                                  value={data.description}
                                  onChange={onHandleChange}
                                  className={`text-inputNew text-inputNew__commentNew`}
                                  placeholder={`Текст резюме`}
                        />
                        <label className={`text-labelNew`}>Текст резюме</label>
                        <Error message={errors.description} />
                    </div>
                    <div className={`form__itemCheckbox mb8`}>
                        <Checkbox name={`checkedPersonal`}
                                  checked={data.checkedPersonal}
                                  onChange={onHandleChange}
                                  label={<span>
                                      <span>Даю согласие на </span>
                                      <Link
                                          href={`/politika-konfidencialnosti`}
                                          className={`form__personal`}
                                          target={`_blank`}
                                      >
                                          обработку персональных данных
                                      </Link>
                                  </span>
                                  }
                        />
                        <Error message={errors.checkedPersonal} />
                    </div>
                    <Error message={errors.errorMessage} className={`errorMessage`} />
                    <button type={`submit`} className={`btn btn__submit`} disabled={processing}>
                        Отправить
                    </button>
                </form>
                :
                <p>Спасибо, Ваша заявка принята</p>
            }
        </div>
    </Dialog>
}

export default useWithStore(JobsForm);
